(function () {
  // Output
  var outputSidebarAjax = document.querySelector(
    "#filter-output .ecommerce-listing #product-row"
  );

  let loadMoreBtn = document.getElementById("load-more");
  // Checkbox click event
  //Chebox filter ajax triggered from here
  let checkBox = document.querySelectorAll(".sidebar-filter .checkbox");
  for (let i = 0; i < checkBox.length; i++) {
    checkBox[i].addEventListener("click", function () {
      const categoryIdElement = document.getElementById("current-category-id");

      // Safely access data attributes
      const categoryId = categoryIdElement.dataset.attrId;
      ajaxSidebarSrollToSection();
      filterProduct(1, "", categoryId);
    });
  }

  //Sub-Categories click event
  let subCategories = document.querySelectorAll(
    ".sub-cat-filter .swiper-wrapper .swiper-slide a"
  );

  if (subCategories) {
    subCategories.forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        subCategories.forEach(function (item) {
          item.classList.remove("active");
        });
        e.preventDefault();
        this.classList.add("active");
        const categoryId = this.dataset.attrId;
        const categoryName = this.dataset.attrName;
        filterProduct(1, { name: categoryName, id: categoryId });
      });
    });
  }

  // Clear filter
  let clearFilter = document.getElementById("clear-ajax-sidebar");

  if (clearFilter) {
    clearFilter.addEventListener("click", function () {
      ajaxSidebarSrollToSection();
      checkBox.forEach(function (item) {
        item.checked = false;
        item.dispatchEvent(new Event("change", { bubbles: true }));
      });

      document
        .querySelectorAll(".filter-with-ajax .cfvsw-selected-swatch")
        .forEach(function (el) {
          el.classList.remove("cfvsw-selected-swatch");
        });

      document
        .querySelectorAll(
          ".filter-with-ajax .cfvsw-swatches-option, .filter-with-ajax .cfvsw-swatches-option .color-swatch"
        )

        .forEach(function (el) {
          var bg = el.style.backgroundColor || "";

          el.style.removeProperty("outline");
          el.style.removeProperty("box-shadow");
          el.style.removeProperty("box-shadow");
          el.style.removeProperty("transform");
          el.style.removeProperty("opacity");
          el.style.removeProperty("filter");
          el.style.removeProperty("border-color");

          if (bg) el.style.backgroundColor = bg;
        });

      document
        .querySelectorAll(".filter-with-ajax .cfvsw-swatches-option")
        .forEach(function (el) {
          if (el.hasAttribute("aria-checked"))
            el.setAttribute("aria-checked", "false");
          if (el.hasAttribute("data-selected"))
            el.removeAttribute("data-selected");
        });

      if (subCategories) {
        subCategories.forEach(function (item) {
          item.classList.remove("active");
        });
      }

      // Remove active class from subcategories
      if (subCategories) {
        subCategories.forEach(function (item) {
          item.classList.remove("active");
        });
      }

      const categoryIdElement = document.getElementById("current-category-id");
      const categoryId = categoryIdElement?.dataset?.attrId || "";
      filterProduct(1, "", categoryId);
    });
  }
  pagination();

  // Pagination function
  function pagination() {
    let pagination = document.querySelectorAll(".pagination .page-link");
    for (let i = 0; i < pagination.length; i++) {
      pagination[i].addEventListener("click", function (e) {
        e.preventDefault();
        ajaxSidebarSrollToSection();
        let pageNo = pagination[i].getAttribute("data-pageno");
        const mainCategoryId = document.getElementById(
          "current-category-id"
        ).value;
        const categoryIdElement = document.querySelectorAll(
          ".sub-cat-filter .swiper-wrapper .swiper-slide a"
        );
        let currentActiveId = null;
        categoryIdElement.forEach(function (item) {
          if (item.classList.contains("active")) {
            currentActiveId = parseInt(item.getAttribute("data-attr-id"));
          }
        });
        const categoryId = currentActiveId ? currentActiveId : mainCategoryId;
        filterProduct(pageNo, "", categoryId);
      });
    }
  }

  loadMore();

  function loadMore() {
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", function (e) {
        e.preventDefault();
        let pageNo = loadMoreBtn.getAttribute("data-page");
        e.target.setAttribute("data-page", parseInt(pageNo) + 1);
        const mainCategoryId = document.getElementById(
          "current-category-id"
        ).value;
        const categoryIdElement = document.querySelectorAll(
          ".sub-cat-filter .swiper-wrapper .swiper-slide a"
        );
        let currentActiveId = null;
        categoryIdElement.forEach(function (item) {
          if (item.classList.contains("active")) {
            currentActiveId = parseInt(item.getAttribute("data-attr-id"));
          }
        });
        const categoryId = currentActiveId ? currentActiveId : mainCategoryId;
        filterProduct(pageNo, "", categoryId);
      });
    }
  }

  // Filter product function
  function filterProduct(page = 1, clickedCategory = null, categoryId = "") {
    ajaxSidebarLoaderShow();

    let categoriesChoices = {};
    let attributesChoices = {};

    if (clickedCategory) {
      categoriesChoices[clickedCategory.name] = [clickedCategory.id];
    } else {
      // Getting values from catergories checkbox
      let categories = document.querySelectorAll(
        ".ecommerce-sidebar-filter .categories input[type=checkbox]"
      );
      for (let i = 0; i < categories.length; i++) {
        if (categories[i].checked) {
          if (!categoriesChoices.hasOwnProperty(categories[i].name))
            categoriesChoices[categories[i].name] = [categories[i].value];
          else categoriesChoices[categories[i].name].push(categories[i].value);
        }
      }
    }

    // Getting values from atrtributes checkbox
    let attributes = document.querySelectorAll(
      ".ecommerce-sidebar-filter .attributes input[type=checkbox]"
    );
    for (let i = 0; i < attributes.length; i++) {
      if (attributes[i].checked) {
        if (!attributesChoices.hasOwnProperty(attributes[i].name))
          attributesChoices[attributes[i].name] = [attributes[i].value];
        else attributesChoices[attributes[i].name].push(attributes[i].value);
      }
    }

    // Categories data to send in request
    let categoriesData = "";
    for (let key in categoriesChoices) {
      if (categoriesChoices.hasOwnProperty(key)) {
        let categoriesArray = categoriesChoices[key];

        for (let i = 0; i < categoriesArray.length; i++) {
          categoriesData +=
            "&categoriesChoices%5B" + key + "%5D%5B%5D=" + categoriesArray[i];
        }
      }
    }

    // Attributes data to send in request
    let attributesData = "";
    for (let key in attributesChoices) {
      if (attributesChoices.hasOwnProperty(key)) {
        let attributesArray = attributesChoices[key];

        for (let i = 0; i < attributesArray.length; i++) {
          attributesData +=
            "&attributesChoices%5B" + key + "%5D%5B%5D=" + attributesArray[i];
        }
      }
    }

    // Handle the Search Paramater As Well
    let searchTerm = document.getElementById("search-query")?.value || "";

    let clearBtnDisplay;
    if (categoriesData == "" && attributesData == "") {
      clearBtnDisplay = "none";
    } else {
      clearBtnDisplay = "block";
    }
    if (document.getElementById("clear-ajax-sidebar")) {
      document.getElementById("clear-ajax-sidebar").style.display =
        clearBtnDisplay;
    }

    // Page data to send in request
    let pageData = "&pageNo=" + page;
    let pageUrlValue = document.getElementById("page-url").value;
    pageUrl = "&pageurl=" + pageUrlValue;

    // Ajax request
    let request = new XMLHttpRequest();
    request.open("POST", ajax_callback_data.ajax_url, true);
    request.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=UTF-8"
    );
    request.onreadystatechange = () => {
      if (request.readyState === 4) {
        const responseData = JSON.parse(request.response);
        if (responseData.data.output === "no-product") {
          responseHtml = '<span class="no-result">No Products Found</span>';
        } else {
          if (responseData.data.finalPage) {
            if (loadMoreBtn) {
              if (!loadMoreBtn.classList.contains("hide")) {
                loadMoreBtn.classList.add("hide");
              }
            }
          } else {
            if (loadMoreBtn) {
              loadMoreBtn.classList.remove("hide");
            }
          }
          responseHtml = responseData.data.output;
        }

        if (page == 1) {
          outputSidebarAjax.innerHTML = responseHtml;

          // Reset Load More button data-page when new results start
          let loadMoreBtnNew = document.getElementById("load-more");
          if (loadMoreBtnNew) {
            loadMoreBtnNew.setAttribute("data-page", "2");
          }
        } else {
          let tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseHtml;
          let newItems = tempDiv.querySelectorAll(
            ".product-wrap, [class*='col-']"
          );
          newItems.forEach(function (item) {
            outputSidebarAjax.appendChild(item);
          });
        }

        ajaxSidebarLoaderHide();
      }
    };

    let categoryIdParam = "";
    if (categoryId) {
      categoryIdParam = "&categoryId=" + encodeURIComponent(categoryId);
    }

    let excludeIds = document.getElementById("exclude-ids")?.value || "";

    // FIX: Build the complete request data string first
    let requestData =
      "action=woocommerce_ajax_filter_products&nonce=" +
      ajax_callback_data.ajax_nonce +
      categoriesData +
      attributesData +
      pageData +
      pageUrl +
      categoryIdParam +
      "&s=" +
      encodeURIComponent(searchTerm);

    // Add exclude_ids if they exist
    if (excludeIds) {
      requestData += "&exclude_ids=" + encodeURIComponent(excludeIds);
    }

    // FIX: Only ONE request.send() call
    request.send(requestData);
  }

  // on click open drop down filter
  let openFilter = document.getElementById("open-filter");
  if (openFilter) {
    openFilter.addEventListener("click", function () {
      let element = document.getElementById("product-filter");
      element.classList.toggle("d-block");
      openFilter.classList.toggle("open");
    });
  }

  function ajaxSidebarLoaderShow() {
    document.getElementById("loading").style.display = "flex";
  }

  function ajaxSidebarLoaderHide() {
    document.getElementById("loading").style.display = "none";
  }

  function ajaxSidebarSrollToSection() {
    let yOffset = -300;
    let SidebarScrollY =
      outputSidebarAjax.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: SidebarScrollY, behavior: "smooth" });
  }
})();

const wrapper = document.getElementById("load-more-wrapper");
const loadMoreBtn = document.getElementById("load-more");

if (wrapper && loadMoreBtn) {
  const observer = new MutationObserver(() => {
    const btnStyle = window.getComputedStyle(loadMoreBtn);
    if (btnStyle.display === "none" || loadMoreBtn.classList.contains("hide")) {
      wrapper.style.display = "none";
    } else {
      wrapper.style.display = "";
    }
  });

  observer.observe(loadMoreBtn, {
    attributes: true,
    attributeFilter: ["class", "style"],
  });

  const btnStyle = window.getComputedStyle(loadMoreBtn);
  if (btnStyle.display === "none" || loadMoreBtn.classList.contains("hide")) {
    wrapper.style.display = "none";
  }
}